import { render, staticRenderFns } from "./ViewReferral.vue?vue&type=template&id=68e61bdc&"
import script from "./ViewReferral.vue?vue&type=script&lang=js&"
export * from "./ViewReferral.vue?vue&type=script&lang=js&"
import style0 from "./ViewReferral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports